import styled, { css } from 'styled-components';

import { Text } from '@olxbr/ds-web';

export const Container = styled.div`
  display: block;
  min-height: 108px;

  div {
    &:first-of-type {
      margin-left: 0px;
    }
    margin-left: var(--spacing-stack-nano);
  }
`;


const bg = css`
  border: var(--border-width-hairline) solid var(--color-neutral-darker);
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-right: var(--spacing-stack-nano);
  background-color: ${({ greyBg }) =>
    (greyBg ? 'grey' : 'var(--color-secondary-medium)')};
  border-radius: 50%;
  ${({ noBg }) => (noBg ? bg : '')};
`;


export const DescriptionContainer = styled(Text.BodySmall)`
  margin: var(--spacing-stack-nano) 0;
  text-align: center;
  color: ${({ disabled }) => (disabled ? 'grey' : 'black')};
`;
